module.exports = __webpack_public_path__ + "Assist_MH_Logo-472b36944ff0dfa63c89eb40abaf9918.svg";